// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';

// import course css modules
import tmStyles from '../contentModuleModuleStyles.css';

const AdminCMQuickListItem = ({ course, match, contentModule }) => {
  return (
    <Link to={`/admin/authoring/content-modules/${contentModule._id}`} target="_blank" className="-item">
      {contentModule.title}
      <div className="-icon">
        <i className="far fa-external-link"/>
      </div>
    </Link>

  )
}

AdminCMQuickListItem.propTypes = {
  course: PropTypes.object
  , contentModule: PropTypes.object.isRequired
}

export default withRouter(AdminCMQuickListItem);



// WEBPACK FOOTER //
// modules/contentModule/components/AdminCMQuickListItem.js.jsx